import AdminNexusHttpClient from './admin-nexus-http-client'

export default class SundryService {
  constructor() {
    this.httpClient = new AdminNexusHttpClient('/admin/sundries')
  }

  async list(property) {
    return await this.httpClient.get(`list/${property}`)
  }
}
